import { Grid2, Typography } from "@mui/material";
import React from "react";
import { ReactComponent as ChatBotIcon } from "../../../../assets/images/ChatBotIcon.svg";
import CommonButton from "../../../../component/Button";
import { HandleSkeletion } from "../../../../utils/constants";
import { CustomDiv } from "../../../chat-bot/style";
import { CommonGrid2 } from "../../../common-components/StyledComponents";
import { CustomizeSpan } from "../../../jobs/style";

export default function SowSummary({
  isLoading,
  sowSummary_clientInformation,
  SowActivate,
  sowButton,
}) {
  return (
    <CustomDiv>
      <Grid2 container spacing={2}>
        <CommonGrid2
          size={{ xs: 12, md: 4, sm: 12 }}
          item
          alignItems={"center"}
          display={"flex"}
        >
          {isLoading ? (
            <HandleSkeletion height={50} width={"100%"} />
          ) : (
            <Typography variant="h3">Sow Summary</Typography>
          )}
        </CommonGrid2>

        <CommonGrid2
          item
          size={{ xs: 12, md: 8, sm: 12 }}
          gap="10px"
          display="flex"
          justifyContent={"end"}
          alignItems={"end"}
          flexDirection={"column"}
          height={"fit-content"}
        >
          <CommonGrid2
            display={"flex"}
            flexDirection={"row"}
            size="12"
            gap={"1rem"}
            flexWrap={"wrap"}
            width={"100%"}
            justifyContent="end"
          >
            <CommonButton
              variant="outlined"
              color="#344054"
              border="#D0D5DD"
              fontWeight="600"
              padding={"10px 20px"}
              value="Activate"
              onClick={SowActivate}
              disabled={isLoading || sowButton.disabled}
              loading={sowButton.loading}
            />
          </CommonGrid2>
        </CommonGrid2>
      </Grid2>
      <CommonGrid2
        display={"flex"}
        gap={"5px"}
        alignItems={"center"}
        margin={"1.5rem 0px 1rem"}
      >
        <CustomDiv>
          {isLoading ? (
            <HandleSkeletion
              width="50px"
              height="50px"
              marginRight={"1rem"}
              transform="scale(1)"
              borderRadius="50px"
            />
          ) : (
            <ChatBotIcon style={{ width: "70px", height: "70px" }} />
          )}
        </CustomDiv>
        <CommonGrid2 display={"flex"} flexDirection={"column"} gap={"5px"}>
          {isLoading ? (
            <HandleSkeletion width="300px" height="30px" transform="scale(1)" />
          ) : (
            <Typography variant="body3" fontWeight={600}>
              {"Here is the AI Analysis of the Job Description !"}
            </Typography>
          )}
          <CommonGrid2 display={"flex"} gap={"10px"} alignItems={"center"}>
            {isLoading ? (
              <HandleSkeletion width="150px" height="30px" />
            ) : (
              <Typography variant="div" fontWeight={500}>
                {"Analysis Score"}
              </Typography>
            )}
          </CommonGrid2>
        </CommonGrid2>
      </CommonGrid2>
      <CommonGrid2 display={"flex"} gap={"1rem"} flexDirection={"column"}>
        {sowSummary_clientInformation.map((item) =>
          isLoading ? (
            <HandleSkeletion width="100%" height="80px" transform="scale(1)" />
          ) : (
            <CommonGrid2
              display={"flex"}
              gap={"1rem"}
              background="#F7F8F9"
              padding={"1rem"}
              borderRadius={"10px"}
              width={"100%"}
            >
              <CustomDiv>{item.icon}</CustomDiv>
              {item.information && (
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  gap="10px"
                >
                  {item.information.map((child, index) => (
                    <Typography variant="body4" fontWeight={700} key={index}>
                      {child.title} :
                      <CustomizeSpan fontWeight={500}>
                        {" "}
                        {child.value}
                      </CustomizeSpan>
                    </Typography>
                  ))}
                </CommonGrid2>
              )}

              {item.purpose && (
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  gap="10px"
                >
                  {item.purpose.map((child, index) => (
                    <>
                      <Typography variant="body4" fontWeight={700}>
                        {child.title} :
                      </Typography>
                      <Typography variant="body4" fontWeight={500}>
                        {" "}
                        {child.value} :
                      </Typography>
                    </>
                  ))}
                </CommonGrid2>
              )}
              {item.assumptions && (
                <CommonGrid2
                  display={"flex"}
                  flexDirection={"column"}
                  gap="10px"
                >
                  {item.assumptions.map((child, index) => (
                    <>
                      <Typography variant="body4" fontWeight={700}>
                        {child.title} :
                      </Typography>

                      <ul style={{ paddingLeft: "30px", margin: "0px" }}>
                        {child.value &&
                          child.value.map((listItem) => (
                            <li
                              style={{
                                fontSize: "15px",
                                color: "#00144A",
                                fontFamily: "Inter",
                                fontWeight: "500",
                              }}
                            >
                              {listItem}
                            </li>
                          ))}
                      </ul>
                    </>
                  ))}
                </CommonGrid2>
              )}
            </CommonGrid2>
          )
        )}
      </CommonGrid2>
    </CustomDiv>
  );
}
